module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADySURBVFiF7ddhCoJAEIbhb6buVV1rCV0jPFceLKcfNWXmlrVjFswLwrqy8ICKLuB5njdp1D2RbVyjbVdzYTSqd9V1rAMJRQlQnEXUj2lD+3gAAJ6ZMlznLiaAEs/HlxIcwLQZurQcmtRnQEKhM3Ey2IIqvZ0SynFACUVJ9a6aDNqDAfqCyjggQFFRptAU7CglWlkPLUkAbwgT6CsYpZc+ARpAM2BvAD+AGsA+AI6EMjcWsAzga6gFzACo3UPB3FjANAOgdnn+WoEFTPvNb3EnB+bmwNwcmJsDc/sjIHMzoyPZ/cY9FI+7lm/X+13zPM+buBOb4qaGOzzJWAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/h4-2.png
// module id = 0EJI
// module chunks = 1